import { AfterViewInit, Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { registerIconSets } from "./icon-sets";
import { FormService } from "./services/form.service";
import { TrackingService } from './services/tracking.service';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { from } from "rxjs";
import { UntypedFormGroup } from "@angular/forms";

@Component( {
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [
		trigger( 'slide', [
			state( '1', style( {left: '0'} ) ),
			state( '2', style( {left: '-100%'} ) ),
			state( '3', style( {left: '-200%'} ) ),
			state( '4', style( {left: '-300%'} ) ),
			state( '5', style( {left: '-400%'} ) ),
			state( '6', style( {left: '-500%'} ) ),
			state( '7', style( {left: '-600%'} ) ),
			state( '8', style( {left: '-700%'} ) ),

			// Extra
			state( '9', style( {left: '-800%'} ) ),
			state( '10', style( {left: '-900%'} ) ),
			state( '11', style( {left: '-1000%'} ) ),
			state( '12', style( {left: '-1100%'} ) ),
			state( '13', style( {left: '-1200%'} ) ),
			transition( '* => *', animate( '550ms ease-out' ) ),
		] ),
	]
} )

export class AppComponent implements AfterViewInit {

	public constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer,
		public formService: FormService,
		public trackingService: TrackingService ) {

		trackingService.setStepWithName( 'movingFrom' );

		registerIconSets( this.matIconRegistry, this.domSanitizer );
	}

	// The form is on screen: start the telemetry session (DEV-7892)
	public ngAfterViewInit(): void {

		this.formService.logFormLoaded();
	}

	public shouldShowPropertyType( fromOrTo: string ) {

		var direction = ( fromOrTo == 'from' ? 'From' : 'To' );
		return this.formService.mainForm.controls['_propertyType' + direction + 'Enabled'].value;
	}

	public shouldShowPropertyTypeDetails( fromOrTo: string ) {

		var direction = ( fromOrTo == 'from' ? 'From' : 'To' );
		return this.formService.mainForm.controls['_propertyTypeDetails' + direction + 'Enabled'].value;
	}

	public shouldShowMovingContent() {

		return (<UntypedFormGroup>this.formService.mainForm.controls['movingSize'] ).controls['movingSize'].value !== 4;
	}

	public shouldShowMovingBoxes() {

		return !this.shouldShowMovingContent();
	}

	public shouldShowConsentMovers() {

		return (<UntypedFormGroup>this.formService.mainForm.controls['_consentMoversEnabled'] ).value;
	}

	public shouldShowUploadPictures() {

		return this.formService.mainForm.controls['_uploadPicturesEnabled'].value;
	}
}
